export const toScroll = ()=>{
  const section = window.location.hash.replace("#", "").trim()
  const el = document.getElementById(section);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}

export const toScrollSection = (section: string)=>{  
  const el = document.getElementById(section);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}